import React, { useEffect, useState } from 'react';
import HomePage from './pages/HomePage';
import FAQPage from './pages/FAQPage';
import NotFoundPage from './pages/NotFoundPage';
import { canonicalPath, matchRoute } from './routes';
import { Toaster } from './toaster';
import './index.css';

function App() {
  const [path, setPath] = useState(
    typeof window !== 'undefined' ? window.location.pathname : '/'
  );

  useEffect(() => {
    const updatePath = () => setPath(window.location.pathname);
    window.addEventListener('popstate', updatePath);
    window.addEventListener('app:navigate', updatePath as EventListener);
    return () => {
      window.removeEventListener('popstate', updatePath);
      window.removeEventListener('app:navigate', updatePath as EventListener);
    };
  }, []);

  useEffect(() => {
    const canonical = canonicalPath(path);
    if (path !== canonical) {
      window.history.replaceState({}, '', canonical + window.location.search + window.location.hash);
      setPath(canonical);
    }
  }, [path]);

  const route = matchRoute(path);

  return (
    <>
      <Toaster />
      {route === 'faq' ? <FAQPage /> : route === 'home' ? <HomePage /> : <NotFoundPage />}
    </>
  );
}

export default App;
